import { render, staticRenderFns } from "./SecondaryInsurance.vue?vue&type=template&id=db75334e&scoped=true&"
import script from "./SecondaryInsurance.vue?vue&type=script&lang=js&"
export * from "./SecondaryInsurance.vue?vue&type=script&lang=js&"
import style0 from "./SecondaryInsurance.vue?vue&type=style&index=0&id=db75334e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db75334e",
  null
  
)

export default component.exports